module.exports = __webpack_public_path__ + "img/img_aboutus_enterprise_hei@2x.73d64823.png";